export const colors = {
  brand: {
    blue: '#2E279D',
    white: '#fff',
    grey: '#F7FAFC',
    green: '#0AB86F',
    red: '#FD397A',
    successBlue: '#2373EC'
  }
}
